import e from "../../../utilities/tw.js";
const a = {
  base: e`inline-flex items-center justify-center gap-1 whitespace-nowrap rounded text-base font-bold uppercase leading-5 tracking-wide outline-offset-4 focus-visible:rounded focus-visible:outline-4 focus-visible:outline-offset-4 disabled:cursor-not-allowed`,
  baseColor: {
    primary: e`focus-visible:outline focus-visible:outline-focus`,
    secondary: e`focus-visible:outline focus-visible:outline-focus-inverse`
  },
  colors: {
    "primary-filled": e`bg-primary text-neutral hover:bg-primary-hover active:bg-primary-active disabled:bg-disabled-surface disabled:text-disabled data-[loading=true]:bg-primary/70`,
    "primary-outlined": e`border-primary text-primary hover:bg-secondary-hover focus-visible:bg-primary focus-visible:text-secondary active:bg-secondary-active disabled:border-disabled-surface disabled:bg-transparent disabled:text-disabled data-[loading=true]:border-primary/70`,
    "primary-ghost": e`text-primary hover:text-primary-hover active:text-primary-active disabled:text-disabled`,
    "secondary-filled": e`bg-secondary text-primary hover:bg-secondary-hover active:bg-secondary-active disabled:bg-disabled-surface disabled:text-disabled data-[loading=true]:bg-secondary-hover/70`,
    "secondary-outlined": e`border-secondary text-secondary hover:bg-secondary-hover  hover:text-primary focus-visible:bg-secondary focus-visible:text-primary active:bg-secondary-active active:text-primary disabled:border-disabled-surface disabled:bg-transparent disabled:text-disabled`,
    "secondary-ghost": e`text-secondary hover:text-secondary-hover active:text-secondary-active disabled:text-disabled`
  },
  size: {
    small: e`px-6 py-3`,
    base: e`px-6 py-4`
  },
  fullWidth: e`w-full`,
  variants: {
    filled: e`border-2`,
    outlined: e`border-2 bg-transparent`,
    ghost: e`bg-transparent px-0`
  }
};
export {
  a as buttonStyles
};
